"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopperManagerStyles = exports.StyledSelectMenu = exports.StyledSelectButton = exports.StyledSelectInput = exports.StyledSelectWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _commonElements = require("../utils/commonElements");

var _Menu = _interopRequireDefault(require("../Menu"));

var _helpers = require("../utils/helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      min-width: 100%;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      display: block;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-height: 300px;\n  display: none;\n  border-bottom: none;\n  box-shadow: ", ",\n    0 1px 0 ", ";\n  transition: opacity ", ";\n  z-index: 2000;\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-align: left;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-overflow: ellipsis;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSelectWrapper = _styledComponents.default.div(_templateObject(), function (props) {
  return props.fullWidth && (0, _styledComponents.css)(_templateObject2());
});

exports.StyledSelectWrapper = StyledSelectWrapper;
var StyledSelectInput = (0, _styledComponents.default)(_commonElements.CalciteSelect)(_templateObject3());
exports.StyledSelectInput = StyledSelectInput;
var StyledSelectButton = (0, _styledComponents.default)(_commonElements.CalciteSelect)(_templateObject4());
exports.StyledSelectButton = StyledSelectButton;
var StyledSelectMenu = (0, _styledComponents.default)(_Menu.default)(_templateObject5(), function (props) {
  return props.theme.boxShadow;
}, function (props) {
  return props.theme.palette.lightestGray;
}, (0, _helpers.transition)(), function (props) {
  return props.isOpen && (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(_templateObject7());
});
exports.StyledSelectMenu = StyledSelectMenu;
var PopperManagerStyles = {
  width: '100%'
};
exports.PopperManagerStyles = PopperManagerStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/Select/Select-styled.js
// module id = 1549
// module chunks = 0